'use strict';

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _select = require('linksoft/initializers/select2');

var Select2 = _interopRequireWildcard(_select);

var _localize = require('linksoft/core/localize');

var _localize2 = _interopRequireDefault(_localize);

var _notify = require('linksoft/notify');

var _notify2 = _interopRequireDefault(_notify);

var _message = require('linksoft/message');

var _message2 = _interopRequireDefault(_message);

var _emailingApi = require('../cart/emailingApi');

var _emailingApi2 = _interopRequireDefault(_emailingApi);

var _smartFormMvc = require('../smartform/smartFormMvc');

var _smartFormMvc2 = _interopRequireDefault(_smartFormMvc);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var $ = require("jquery");


var Resx = (0, _localize2.default)('Common', 'App', 'Messages');
var customerService = abp.services.api.customerB2c;

module.exports = exports.default = function () {

    $("#customerDetail", this).off("click").on("click", "a[data-modal-link]", function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(e) {
            var $buttonClicked, url, targetId;
            return _regenerator2.default.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            e.preventDefault();
                            $buttonClicked = $(this);
                            url = $buttonClicked.attr("data-url");
                            targetId = $buttonClicked.attr("data-target-id");


                            $.get(url, function () {
                                var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(data) {
                                    var targetDialog;
                                    return _regenerator2.default.wrap(function _callee$(_context) {
                                        while (1) {
                                            switch (_context.prev = _context.next) {
                                                case 0:
                                                    targetDialog = $('#' + targetId);

                                                    targetDialog.children().children().html(data);

                                                    Select2.initSelect2($("#CountryId"));
                                                    $.validator.unobtrusive.parse("form");

                                                    targetDialog.modal("show");
                                                    _context.next = 7;
                                                    return _smartFormMvc2.default.registerSmartFormCallBack('smartform-instance-paralel');

                                                case 7:
                                                case 'end':
                                                    return _context.stop();
                                            }
                                        }
                                    }, _callee, this);
                                }));

                                return function (_x2) {
                                    return _ref2.apply(this, arguments);
                                };
                            }());

                        case 5:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, this);
        }));

        return function (_x) {
            return _ref.apply(this, arguments);
        };
    }()).on("click", "a[customer-card-delete-button]", function (e) {
        e.preventDefault();
        var $buttonClicked = $(this);
        _message2.default.confirm(Resx.App.CustomerCardDeleteConfirmation, Resx.Messages.ConfirmTitle, function (isConfirmed) {
            if (isConfirmed) {
                var deleteCardUrl = $buttonClicked.attr("data-url");
                var elementToUpdate = '#' + $buttonClicked.attr("data-update-target");
                $.post(deleteCardUrl, function (data) {
                    $(elementToUpdate).html(data);
                    _notify2.default.success(Resx.App.CustomerCardDeleteConfirmed);
                }).fail(function () {
                    _notify2.default.error(Resx.Common.AjaxError);
                });
            }
        });
    });

    $("[close-account-button]", this).on("click", function () {
        var $buttonClicked = $(this);
        var redirectUrl = $buttonClicked.attr("data-url");
        _message2.default.confirm(Resx.App.CloseAccountConfirmationText, Resx.App.CloseAccountConfirmationTitle, function (isConfirmed) {
            if (isConfirmed) {
                customerService.closeCustomerAccount().done(function () {
                    _notify2.default.success(Resx.App.AccountWasClosed);
                    window.location = redirectUrl;
                }).fail(function (result) {
                    _notify2.default.error(result.responseJSON.error.message);
                });
            }
        });
    });

    _emailingApi2.default.completeOrderMessage();
};


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/initializers/customerActions.js
// module id = 1064
// module chunks = 0